import React, { useState, useEffect } from 'react';
import { message, Divider } from 'antd';
import copy from 'copy-to-clipboard'
import PageWrap from '../../components/PageWrap'
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { post, postFrom, config } from '../../axios';
import { formatTime } from '../../utils/index'
import { channelStatus } from '../../axios/dictionaries'
import ChannelUpdate from './components/ChannelUpdate'

const params = { keyword: '', status: -1, pageSize: 10 }

const Channel = () => {
    const [loading, setLoading] = useState(false)
    const [queryData, setQueryData] = useState(() => params)
    const [current, setCurrent] = useState(1)
    const [tableTotal, setTableTotal] = useState(1)
    const [tableData, setTableData] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState({})

    useEffect(() => {
        handleSearch()
    }, [])

    const searchFormItem = [
        {
            tagName: 'InputTip',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
            title: '在名称跟token查询模糊查询'
        },
        {
            tagName: 'Select',
            formConfig: { name: 'status' },
            attribute: { placeholder: '请选择状态', style: { width: '160px' } },
            optionData: channelStatus
        },
    ]

    const columns = [
        { title: '渠道名称', dataIndex: 'name' },
        { title: '渠道 token', dataIndex: 'token' },
        { title: '渠道负责人', dataIndex: 'channelHeadName' },
        {
            title: '状态', dataIndex: 'status',
            render(text) {
                if (!text) return '-'
                const item = channelStatus.find(item => item.value === text)
                if (!item) return '-'
                return <span style={{ color: item.color }}>{item.title}</span>;
            }
        },
        {
            title: '创建时间', dataIndex: 'createTime',
            render(text) {
                if (!text) return '-'
                return formatTime(text)
            }
        },
        {
            title: '操作', dataIndex: 'action',
            render(text, record) {
                return (
                    <div>
                        <AuthButton authkey="k-1-2">
                            <span className="showClickDetail" onClick={() => { handleEdit(record) }}>编辑</span>
                        </AuthButton>
                        <Divider type="vertical" />
                        <AuthButton authkey="k-1-3">
                            <span className="showClickDetail" onClick={() => { handleUpdateStatus(record) }}>{ record.status === 1 ? '停用': '启用' }</span>
                        </AuthButton>
                        <Divider type="vertical" />
                        <AuthButton authkey="k-1-4">
                            <span className="showClickDetail" onClick={() => { handleCopyUrl(record.id) }}>复制地址</span>
                        </AuthButton>
                    </div>
                )
            }
        }
    ]

    const handleSearch = (values = {}) => { //表单搜索/分页

        let data = {};
        if (values.current) {
            data = Object.assign(queryData, values);
        } else {
            data = Object.assign({}, queryData, values, { current });
        }
        setQueryData(Object.assign({}, queryData, values))
        setLoading(true)
        postFrom({
            url: config.API_channel_findPage,
            data,
        }).then(res => {
            let records = res.records;
            records.map(item => item.updateTime = formatTime(item.updateTime))
            const { current, total } = res
            setCurrent(current)
            setTableTotal(total)
            setTableData(records)
            setLoading(false)
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            setLoading(false)
        });
    }

    const handleEdit = (record) => { //编辑
        setModalData(record)
        setVisible(true)
    }

    const handleAdd = () => { //新增
        setModalData({})
        setVisible(true)
    }

    const handleUpdateStatus = ({status, id}) => { //更新状态
        const nowState = status === 1 ? 2 : 1
        const data = { id, status: nowState }
        post({
            url: config.API_channel_updateStatus,
            data
        }).then(res => {
            message.success('状态修改成功!')
            handleSearch()
        }).catch(err => {
            message.error(err.message || '状态修改失败!');
            setLoading(false)
        });
    }

    const handleCopyUrl = (id) => { // 复制地址
        post({
            url: config.API_channel_getUrl,
            data: { id }
        }).then(res => {
            copy(res)
            message.success('复制成功!')
        }).catch(err => {
            message.error(err.message || '获取地址失败!');
            setLoading(false)
        });
    }

    return (
        <PageWrap
            loading={loading}
        >
            <div className="search-wrapper">
                <div className="search-btn-list">
                    <AuthButton authkey="k-1-1" type="primary" icon="plus" onClick={handleAdd}>新增</AuthButton>
                </div>
                <SuperForm
                    data={searchFormItem}
                    sumbit={handleSearch}
                    addParams={'current'}
                    // showCancel={false}
                />
            </div>

            <TableDOM
                columns={columns}
                data={tableData}
                total={tableTotal}
                current={current}
                onChange={handleSearch}
            />

            <ChannelUpdate
                visible={visible}
                handleFindPage={handleSearch}
                modalData={modalData}
                handleCancel={() => { setVisible(false) }}
            />
        </PageWrap>
    )
}

export default Channel


// WEBPACK FOOTER //
// ./src/page/Employee/Channel.jsx